import React from 'react';
import type { SocialNetworkNames } from 'src/components/AuthNew/utils/socialNetworkUtils';
import classnames from 'classnames';
import styles from './socialAuth.module.css';
import type { SocialAuthMethods } from './getSocialAuthMethods';

interface Props {
  className?: string;
  disabled: boolean;
  loginSocialNetwork: (data: SocialNetworkNames) => void;
  arraySocialAuthMethods: SocialAuthMethods[];
}

export const SocialAuth: React.FC<Props> = ({
  className,
  loginSocialNetwork,
  disabled,
  arraySocialAuthMethods,
}) => (
  <div className={classnames(styles.socialContainer, className)}>
    {arraySocialAuthMethods.map(
      ({ icon, networkName, isShow }) =>
        isShow && (
          <button
            className={styles.socialItem}
            key={networkName}
            type="button"
            disabled={disabled}
            onClick={() => loginSocialNetwork(networkName)}
          >
            {icon}
          </button>
        ),
    )}
    {/* временно скрыли тк в РФ не работает facebook */}
    {/* <SocialItem */}
    {/*   type="button" */}
    {/*   disabled={disabled} */}
    {/*   onClick={() => loginSocialNetwork('fb')} */}
    {/* > */}
    {/*   <FbIcon /> */}
    {/* </SocialItem> */}
  </div>
);
